import type { FacilitySearchResult } from "../queries";
import { displayableFacilityLegacyId } from "@/lib/sectionLegacyId";

const archivedSecondaryClassName = "italic text-sys-brand-outline";

export function getFacilityNameSecondaryText(row: FacilitySearchResult) {
  const isArchived = row.archivedAt != null;
  const displayableLegacyId = displayableFacilityLegacyId(row.legacyId);

  if (isArchived && displayableLegacyId) {
    return <span className={archivedSecondaryClassName}>Archived • ID: {displayableLegacyId}</span>;
  }

  if (isArchived) {
    return <span className={archivedSecondaryClassName}>Archived</span>;
  }

  if (displayableLegacyId) {
    return `ID: ${displayableLegacyId}`;
  }

  return " ";
}
